const CREATOR_CLIENTS_DOMAIN = 'creatorClients'

export { CREATOR_CLIENTS_DOMAIN }
